module.exports = __webpack_public_path__ + "img/_logo-1.8e1090e5.png";